import { render, staticRenderFns } from "./PrEdit.vue?vue&type=template&id=4f7cd72c&scoped=true&"
import script from "./PrEdit.vue?vue&type=script&lang=js&"
export * from "./PrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7cd72c",
  null
  
)

export default component.exports